module.exports = __webpack_public_path__ + "img/horizon_line.009d6c3e.svg";